<template>
  <div>
    <div class="">
      <div class="mb-3">
        <h3 class="font-medium text-base mb-1 text-gray-700">Select Event Type <span class="text-gray-500" v-if="!identified">(you must identify first)</span></h3>
        <div class="flex">
          <div class="w-1/4 mr-3">
            <select class="form-select" v-model="selectedEvent" @change="selectEvent($event)">
              <option value="identify">Identify</option>
              <option value="track">Track</option>
              <option value="group">Group</option>
              <option value="page">Page View</option>
            </select>
          </div>
          <div class="w-1/4">
            <input type="text" class="form-input" placeholder="Event Name" v-model="eventName" v-show="selectedEvent == 'track'">
            <input type="text" class="form-input" placeholder="Primary Key (email/cID)" v-model="primaryKey" v-show="selectedEvent == 'identify'">
            <input type="text" class="form-input" placeholder="Group/List" v-model="groupId" v-show="selectedEvent == 'group'">
          </div>
        </div>

      </div>
      <div class="border-gray-300 border-2" v-if="selectedEvent != 'page'">
        <codemirror
          ref="myCm"
          :value="cmData"
          :options="cmOptions"
          @input="onCmCodeChange"
        >
        </codemirror>
      </div>
      <div class="mt-2 flex justify-between items-center">
        <div class="flex justify-start items-center">
          <button class="bg-blue-600 hover:bg-blue-800 text-white px-4 py-2 mr-2" @click="sendEvent(selectedEvent)">
            Send {{ selectedEvent | uppercase(true) }}
          </button>
          <span class="text-gray-600" v-if="selectedEvent == 'identify' && triggeredCount.identify > 0">Identify calls made: {{triggeredCount.identify}}</span>
          <span class="text-gray-600" v-if="selectedEvent == 'track' && triggeredCount.track > 0">Track calls made: {{triggeredCount.track}}</span>
          <span class="text-gray-600" v-if="selectedEvent == 'group' && triggeredCount.group > 0">Group calls made: {{triggeredCount.group}}</span>
          <span class="text-gray-600" v-if="selectedEvent == 'page' && triggeredCount.page > 0">Page calls made: {{triggeredCount.page}}</span>
        </div>
        <button v-if="identified" @click.prevent="reset" class="bg-gray-600 hover:bg-gray-800 text-white px-4 py-2 mr-2">Reset the Page</button>
      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/base16-light.css";

//eslint-disable-next-line no-unused-vars
let trackData = '{\n  "type": "",\n  "color": ""\n}';
let identifyData = '{\n  "email": "",\n  "age": ""\n}';

export default {
  components: {
    codemirror
  },
  data() {
    return {
      identified: false,
      cmData: identifyData,
      selectedEvent: "identify",
      eventName: null,
      primaryKey: null,
      groupId: null,
      cmOptions: {
        // codemirror options
        readOnly: false,
        tabSize: 2,
        mode: "javascript/json",
        // theme: "base16-dark",
        theme: "base16-light",
        lineNumbers: true,
        line: true
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      triggeredCount: {
        identify: 0,
        track: 0,
        group: 0,
        page: 0
      }
    };
  },
  methods: {
    onCmCodeChange(newCode) {
      this.cmData = newCode;
    },
    selectEvent(event) {
      if(event.target.value == 'track')
      {
        this.cmData = trackData
      }

      if(event.target.value == 'identify')
      {
        this.cmData = identifyData
      }

      if(event.target.value == 'group') {
        this.cmData = '{\n\n}'
      }

      if(event.target.value == 'page')
      {
        this.cmData = null
      }
    },
    reset() {
      if( this.identified ) {
        window.analytics.reset();
        location.reload();
      }
    },
    sendEvent(event) {
      if( event == 'identify') {
        this.identified = true;
        window.analytics.identify(this.primaryKey, JSON.parse(this.cmData))
        this.triggeredCount.identify++;
        console.log('Identify triggered', {primaryKey: this.primaryKey, data: JSON.parse(this.cmData)});
      }

      if( event == 'track' ) {
        window.analytics.track(this.eventName, JSON.parse(this.cmData))
        this.triggeredCount.track++;
        console.log('Track triggered', {eventName: this.eventName, data: JSON.parse(this.cmData)});
      }

      if( event == 'group' ) {
        window.analytics.group(this.groupId, JSON.parse(this.cmData));
        this.triggeredCount.group++;
        console.log('Group triggered', {groupId: this.groupId, data: JSON.parse(this.cmData)});
      }

      if( event == 'page') {
        window.analytics.page();
        this.triggeredCount.page++;
        console.log('Page triggered')
      }
    }
  },
  filters: {
    uppercase: function(value, onlyFirstCharacter) {
      if (!value) {
        return "";
      }

      value = value.toString();

      if (onlyFirstCharacter) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else {
        return value.toUpperCase();
      }
    }
  }
};
</script>

<style>
.cm-s-default .cm-string {
    color: #a11 !important;
}
</style>
